// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "main") return "bundle.7.1.38.js";
	// return url for filenames based on template
	return "" + chunkId + ".bundle.7.1.38.js";
};